import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-Bjtexw5f.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';
import { b as angleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { C as Checkbox } from '../../Checkbox/Checkbox-ap_FISoo.js';
import { I as Icon } from '../../Icon/Icon-DowU4ANk.js';

const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-0"
})(["display:flex;padding-inline-start:", ";padding-inline-end:", ";padding-block-start:", ";padding-block-end:", ";:not(:last-child){border-bottom-color:", ";padding-block-end:", ";border-bottom-style:solid;border-width:1px;}"], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.small, ({
  $isSelected,
  theme
}) => $isSelected ? theme.card.selected.borderColor : theme.divider.color, ({
  theme
}) => theme.spacing.micro);
const ClickableContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-1"
})(["margin:0;padding:0;border:0;background:inherit;font:inherit;font-size:inherit;color:inherit;text-decoration:inherit;text-align:inherit;vertical-align:inherit;flex:1;display:flex;align-items:center;", ""], ({
  $isClickable
}) => $isClickable && {
  cursor: 'pointer'
});
const StartColumn = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-2"
})(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.small);
const CenterColumn = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-3"
})(["flex-grow:1;"]);
const EndColumn = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-4"
})(["display:flex;align-items:center;margin-inline-start:", ";font-size:", ";", ""], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.typography.size.base, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.typography.mobile.size.base)));
const CheckboxWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-5"
})(["height:100%;margin:-10px;padding:10px;cursor:pointer;"]);
CheckboxWrapper.displayName = 'CheckboxWrapper';
const PositionedCheckbox = /*#__PURE__*/styled(Checkbox).withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-6"
})(["> div{margin-inline-start:", ";}"], ({
  theme
}) => theme.spacing.none);
const StyledIcon = /*#__PURE__*/styled(Icon).attrs(props => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(props, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30054544__sc-1uptxev-7"
})(["color:", ";:focus{outline:none;", "}:hover{color:", ";}"], ({
  theme
}) => theme.icon.color, ({
  focusVisible
}) => focusVisible && focusOutline, ({
  theme
}) => theme.icon.hover.color);
const handleStopPropagation = event => event.stopPropagation();
const getClickableContainerAs = ({
  href,
  onClick
}) => {
  if (typeof href === 'string') {
    return 'a';
  }
  if (typeof onClick === 'function') {
    return 'button';
  }
  return 'div';
};
const Content = ({
  href,
  id,
  isSelected,
  onSelect,
  onClick,
  ariaLabel,
  children,
  ...restProps
}) => {
  const isClickable = typeof href === 'string' || typeof onClick === 'function';
  return /*#__PURE__*/React__default.createElement(Container, {
    $isSelected: isSelected
  }, onSelect && /*#__PURE__*/React__default.createElement(StartColumn, {
    onClick: handleStopPropagation,
    onKeyUp: handleStopPropagation,
    role: "none"
  }, /*#__PURE__*/React__default.createElement(CheckboxWrapper, {
    onClick: event => onSelect && onSelect(event),
    onKeyUp: event => event.key === KEYBOARD_KEYNAMES.ENTER && onSelect && onSelect(event),
    role: "none"
  }, /*#__PURE__*/React__default.createElement(PositionedCheckbox, {
    id: `${id}_checkbox`,
    label: ariaLabel,
    hideLabel: true,
    checked: isSelected,
    size: "large",
    positionWithLabel: "start"
  }))), /*#__PURE__*/React__default.createElement(ClickableContainer, _extends({}, restProps, isClickable && {
    'aria-label': ariaLabel
  }, {
    as: getClickableContainerAs({
      href,
      onClick
    }),
    href: href,
    onClick: event => {
      if (onClick) {
        onClick(event);
      }
    },
    $isClickable: isClickable
  }), /*#__PURE__*/React__default.createElement(CenterColumn, {
    id: `${id}_center_column`
  }, children), onClick && /*#__PURE__*/React__default.createElement(EndColumn, null, /*#__PURE__*/React__default.createElement(StyledIcon, {
    type: angleInlineEnd,
    size: "lg"
  }))));
};
Content.defaultProps = {
  href: undefined,
  isSelected: false,
  onSelect: undefined,
  onClick: undefined
};

export { Content as C };
//# sourceMappingURL=Content-BnrRXv-B.js.map
